export function toHsocFeatureItem(feature) {
  /* name and shortDescription are display strings returned by the API, not
   * i18n keys — they must not be wrapped in I18n.text() or FormattedMessage. */
  return Object.assign({
    key: feature.name,
    label: feature.shortDescription || feature.name,
    isAvailable: true
  }, feature.showName ? {
    name: feature.name
  } : {});
}